var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 102,
    viewBox: "0 0 343 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5106 0H0V108H12.5106V0Z",
    fill: "#1E3966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1055 0H19.8076V108H27.1055V0Z",
    fill: "#1E3966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.228 0H34.4053V108H38.228V0Z",
    fill: "#1E3966"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0219 0H70.1992V108H74.0219V0Z",
    fill: "#1E3966"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7738 0H43.4404V108H59.7738V0Z",
    fill: "#1E3966"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1408 0H78.1904V108H85.1408V0Z",
    fill: "#1E3966"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.341 0H93.8301V108H106.341V0Z",
    fill: "#1E3966"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.935 0H115.027V108H120.935V0Z",
    fill: "#1E3966"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.964 0H125.105V108H137.964V0Z",
    fill: "#1E3966"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.603 0H148.043V108H153.603V0Z",
    fill: "#1E3966"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.198 0H159.857V108H168.198V0Z",
    fill: "#1E3966"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.05 0H176.191V108H189.05V0Z",
    fill: "#1E3966"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.035 0H197.737V108H205.035V0Z",
    fill: "#1E3966"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.666 0H214.07V108H228.666V0Z",
    fill: "#1E3966"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.965 108H343V0.000213623H333.965V108Z",
    fill: "#1E3966"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M317.631 108H325.972V0.000213623H317.631V108Z",
    fill: "#1E3966"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M306.857 108H310.332V0.000213623H306.857V108Z",
    fill: "#1E3966"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M279.751 108H299.56V0.000213623H279.751V108Z",
    fill: "#1E3966"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M266.893 108H272.453V0.000213623H266.893V108Z",
    fill: "#1E3966"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M240.136 108H246.392L246.392 0.000213623H240.136L240.136 108Z",
    fill: "#1E3966"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M251.951 108H260.639V0.000213623H251.951L251.951 108Z",
    fill: "#1E3966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCode);
export default __webpack_public_path__ + "static/media/bar-code.cc63753b3e9ea7d337d5b3ebdb203836.svg";
export { ForwardRef as ReactComponent };